<template>
  <div v-if="!$localStorage.get($store.storeName)" class="login-wrapper">
    <div class="login-container" v-if="$store.state.auth == 0||$store.state.auth == 4">
    

      <!-- forget password -->
         <!-- شاشة إعادة تعيين كلمة المرور مخفية أصلاً -->
    <div v-if="forgetPass" id="reset-password-form">
      <h1  class="Reset_password">{{$t('Reset your password')}}</h1>
      <p>{{ $t('We will send you an email to reset your password')}}</p>
      <form @submit.prevent="resetpass" @keydown="form.onKeydown($event)" id="reset-form">
        <input type="email"  v-model="passemail"
              placeholder="example@gmail.com" required/>
       <button type="submit" class="signin">
        <i class="fa fa-spinner fa-spin " v-if="loading_register" style="color:white"></i>

        {{$t('submit')}}</button>
            <a class="create-account" @click="forgetPass=false">{{$t('cancel')}}</a>
      </form>
      <p class="error-message" style="color:red;height:30px">{{ errorMessage }}</p>

   
    </div>
       <!-- end forget password -->
          <!-- Login Screen -->
      <div v-else-if="forgetVodal" id="login-form">
        <h1>{{ $t('logIn') }}</h1>

        <form @submit.prevent="submitInfo" @keydown="form.onKeydown($event)">
          <input type="email" v-model="form.email" placeholder="example@gmail.com" required />
          <input
            type="password"
            v-model="form.password"
            :placeholder="$t('EnterPass')"
            minlength="8"
            required
          />
          <a class="forgot-password" @click="forgetPass=true" id="forgot-link">
            {{ $t('forgetpass') }}
          </a>
          <button   type="submit" :disabled="form.busy" class="signin">
          <i class="fa fa-spinner fa-spin " v-if="loading_register" style="color:white"></i>

            {{ $t('logIn') }}
          </button>
        </form>
       


        <router-link
          class="create-account"
          :to="{ name: 'register', params: { storeName: $store.storeName, lang: $i18n.locale } }"
        >
          {{ $t('create Account') }}
        </router-link>
         <p class="error-message" style="color:red;height:30px">{{ errorMessage }}</p>
      </div>

      <!-- Password Reset (Email Modal) -->
      <vodal :show="forgetEmailVodal" animation="slideLeft" @hide="forgetEmailVodal = false" :width="500" :height="350">
        <div class="container modal-content">
          <h5 class="modal-title">{{ $t("contactUs") }} :</h5>
          <div class="text-center contact-info">
            <a :href="whatsAppLink" target="_blank">
              <h5><i class="bi bi-telephone-fill"></i> {{ $store.state.phone }}</h5>
            </a>
            <a :href="mailtoLink" target="_blank">
              <h5><i class="bi bi-envelope-fill"></i> {{ $store.state.email }}</h5>
            </a>
          </div>
          <p class="error-message">{{ errorMessageVodal }}</p>
        </div>
      </vodal>

      <!-- Code Modal -->
      <div v-if="codeVodal">
          <h2>{{ $t("EntertheCode") }} :</h2>
          <div>
          <input
            class="code-input"
            v-model="finalcode"
            type="text"
            minlength="6"
            maxlength="6"
            required
          />
          <p class="countdown">{{ countDown }} {{ $i18n.locale == 'en' ? 'second' : 'ثانية' }}</p>
          <button v-if="countDown == 0"  class="signin" @click="ResendCode">
                      <i class="fa fa-spinner fa-spin " v-if="loading_register" style="color:white"></i>

            {{ $t("ResendCode") }}</button>
          <button  class="signin" @click="checkCode" :disabled="countDown == 0">
          <i class="fa fa-spinner fa-spin " v-if="loading_register" style="color:white"></i>

            {{ $t("continue") }}
          </button>
          <p class="error-message">{{ errorMessageVodal }}</p>
        </div>
      </div>

      <!-- New Password Modal -->
      <div v-if="newPassVodal" animation="slideLeft" >
          <h2>{{ $t("EnterNewPass") }} :</h2>
          <div>
          <input
            id="newpassword"
            class="input-field"
            type="password"
            v-model="Newpassword"
            :placeholder="$t('EnterPass')"
            required
            minlength="8"
          />
          <button  @click="SaveChanges"  class="signin">
                      <i class="fa fa-spinner fa-spin " v-if="loading_register" style="color:white"></i>
{{ $t("SaveChanges") }}</button>
          <p class="error-message" style="color:red;height:30px">{{ errorMessageVodal }}</p>
        </div>
      </div>

    </div>

    <!-- Placeholder فقط في حالة auth !== 0 -->
    <div v-else class="redirect-placeholder">
    
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import Vodal from 'vodal';
import 'vodal/common.css';
import 'vodal/slide-left.css';

export default {
  components: { Vodal },
  data() {
    return {
      forgetVodal:true,
      loading_register:false,
      forgetEmailVodal: false,
      forgetPass:false,
      codeVodal: false,
      newPassVodal: false,
      errorMessageVodal: '',
      errorMessage: '',
      passemail: '',
      Newpassword: '',
      finalcode: '',
      countDown: 90,
      emailTrue: false,
      phone: null,
      form: new Form({ email: '', password: '', fsm_token: this.$store.state.fsm_token })
    };
  },
  computed: {
    whatsAppLink() {
      return `https://api.whatsapp.com/send?phone=${this.$store.state.phone}&text=Hello!`;
    },
    mailtoLink() {
      return `mailto:${this.$store.state.email}`;
    }
  },
  created() {
    this.$store.state.showHeader = true;
        this.$store.state.showFooter = true;
    if (this.$localStorage.get(this.$store.storeName)) {
      this.$router.push({ name: 'home1', params: { storeName: this.$store.storeName, lang: this.$i18n.locale } });
    } else if (this.$store.state.auth !== 0&&this.$store.state.auth != 4) {
      
      if (this.$store.state.sms_type == '0') {
        this.$router.push({ name: 'loginPhonesms', params: { storeName: this.$store.storeName, lang: this.$i18n.locale } });
      } else {
        this.$router.push({ name: 'loginPhone', params: { storeName: this.$store.storeName, lang: this.$i18n.locale } });
      }
    }

    const { title_ar, title_en, description_ar, description_en, keyword_ar, keyword_en } = this.$store.state;
    document.title = this.$i18n.locale == 'ar' ? title_ar : title_en;
    document.getElementById('description_meta').content = this.$i18n.locale == 'ar' ? description_ar : description_en;
    document.getElementById('keywords_meta').content = this.$i18n.locale == 'ar' ? keyword_ar : keyword_en;
  },
  methods: {
    async submitInfo() {
      this.loading_register=true;
      const response = await this.form
      
        .post(
          this.$store.state.base_api_url + this.$store.storeName + "/login",
          {
            email: this.form.email,
            password: this.form.password,
            fsm_token: this.form.fsm_token,
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          if (response.data.code == "1") {
            this.loading_register=false;
            ////////////// , initializes a session with a 'session-id'.///////////////////
            //this.$localStorage.start();
            this.$localStorage.set(
              this.$store.storeName,
              response.data.data.token
            );
            //this.$localStorage.set("userToken", response.data.data.token);
            console.log(
              this.$localStorage.get(this.$store.storeName) +
                " " +
                this.$store.storeName
            );

            //console.log("login user token : " + this.$session.get("userToken"));
            /*this.$router.push({
              name: "home1",
              params: { storeName: this.$store.storeName },
            });
            window.location.reload();*/
            window.location.href =
              "/";
            //window.location.href= "https://192.168.1.16:8000/"+this.$store.storeName +"/profile"
          } else if (response.data.code == "-1") {
            this.loading_register=false;
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = "response.data.error";
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        });
    },
    openForgetModal() {
      this.forgetEmailVodal = true;
      this.passemail = '';
    },
    async ResendCode() {
      const val = this.emailTrue ? { email: this.passemail } : { phone: this.phone };
      try {
        const { data } = await this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/forget_password`, val);
        if (data.code == '1') {
          this.countDown = 120;
          this.startCountdown();
          this.errorMessageVodal = data.message;
        } else {
          this.errorMessageVodal = data.message;
        }
      } catch {
        this.errorMessageVodal = 'Error sending code';
      } finally {
        setTimeout(() => (this.errorMessageVodal = ''), 3000);
      }
    },
    async checkCode() {
      
      if (!this.finalcode || this.finalcode.length < 6) {
        this.errorMessageVodal = this.$i18n.locale == 'en' ? "Your code isn't complete" : 'الرمز المدخل غير مكتمل';
        return setTimeout(() => (this.errorMessageVodal = ''), 3000);
      }
      try {
        this.loading_register=true;
        const { data } = await this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/verivey_reset_password`, {
          code: this.finalcode,
          email: this.passemail,
          phone: this.phone
        });
        if (data.code == '1') {
          this.loading_register=false;
          this.codeVodal = false;
          this.newPassVodal = true;
        } else {
          this.loading_register=false;
          this.errorMessageVodal = data.message;
        }
      } catch {
        this.errorMessageVodal = 'Code verification failed';
      } finally {
        setTimeout(() => (this.errorMessageVodal = ''), 3000);
      }
    },
    async SaveChanges() {
      if (!this.Newpassword || this.Newpassword.length < 8) {
        this.errorMessageVodal = 'Password too short';
        return setTimeout(() => (this.errorMessageVodal = ''), 3000);

      }
      try {
                this.loading_register=true;

        const { data } = await this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/update_password`, {
          password: this.Newpassword,
          email: this.passemail,
          phone: this.phone,
          fsm_token: this.form.fsm_token
        });
        if (data.code == '1') {
                  this.loading_register=false;

          this.$localStorage.set(this.$store.storeName, data.data.token);
          window.location.href = '/';
        } else {
            this.loading_register=false;

          this.errorMessageVodal = data.message;
        }
      } catch {
        this.errorMessageVodal = 'Password update failed';
      } finally {
        setTimeout(() => (this.errorMessageVodal = ''), 3000);
      }
    },
    startCountdown() {
      const interval = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    async resetpass() {
      this.loading_register=true;      
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/forget_password",
          {
            ///update_password
            email: this.passemail
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          if (response.data.code == "1") {
                  this.loading_register=false;
            this.forgetVodal = false;
            this.forgetPass = false;
            this.forgetEmailVodal = false;
            this.codeVodal = true;
            this.emailTrue = true;
            this.countDown = 120;
            this.countDownTimer();
            // console.log(response.data.message);
          } else if (response.data.code == "-1") {
                  this.loading_register=false;

            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        });
    },
     countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          if (this.countDown > 0) {
            this.countDown -= 1;
            this.countDownTimer();
          }
        }, 1000);
      }
    },
  }
};
</script>

<style scoped>
.modal-content {
  width: 80%;
  margin: 10%;
}
.modal-title {
  color: var(--primary-color);
  margin: 20px;
}
.contact-info h5 {
  margin-top: 20px;
}
.code-input {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.countdown, .error-message {
  text-align: center;
  margin-top: 10px;
}
.resend-btn, .confirm-btn {
  margin-top: 10px;
  display: block;
  width: 100%;
  padding: 10px;
  background-color: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
